import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import sortBy from 'lodash/sortBy';
import TabsContext from '../../TabsContext';
import Item from './Item';
const Group = function Group(props) {
    const { header, records, value, nodeSuffix, defaultKey } = props;
    const { prefixCls, tabDraggable } = useContext(TabsContext);
    return (React.createElement(React.Fragment, null,
        header && (React.createElement("div", { className: `${prefixCls}-customization-group-header` }, header)),
        React.createElement(Droppable, { isDropDisabled: !tabDraggable, droppableId: value, key: "group" }, (droppableProvided) => (React.createElement("div", Object.assign({ ref: droppableProvided.innerRef, className: `${prefixCls}-customization-group` }, (droppableProvided && droppableProvided.droppableProps)),
            sortBy(records, [r => r.get('sort')]).map((record, index, list) => (React.createElement(Draggable, { key: record.key, draggableId: String(record.key), index: index }, (provided, snapshot) => (React.createElement(Item, { key: record.key, record: record, suffix: nodeSuffix, index: index, records: list, provided: provided, snapshot: snapshot, defaultKey: defaultKey }))))),
            droppableProvided && droppableProvided.placeholder)))));
};
Group.displayName = 'Group';
export default observer(Group);
